import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.scss";
import "bootstrap/dist/js/bootstrap.bundle.min";
import store from "./redux/store/store";
import { Provider } from "react-redux";
import './i18n'
import "./index_ar.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
const currentLang = localStorage.getItem('current_lang') || 'en'; 
 


root.render(
  <React.StrictMode>
    <Provider store={store}>
         <App />
    </Provider>
  </React.StrictMode>
);
